import {
    Row, Col, Label, Input, FormGroup,
} from 'reactstrap';

const NonContiguousForm = ({name,selectOption,label, formErrors,itemPopup,form, masterWaterwayItemList, handleFormFieldChange, isNonContiguous }) => {

    return (
        <>
            {
                masterWaterwayItemList.length > 0 &&
                <>
                    <Row>
                        <Col sm="12">
                            <Label for="inherentRisks">{name}</Label>
                        </Col>
                        <Col sm="12">
                            <Label className="info-text" style={{ fontSize: "14px" }}>{label}</Label>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="6">
                            <Row>
                                <Col sm="12">
                                    <FormGroup check>
                                        <Label
                                            check
                                            for="isNonContiguousItem"
                                        >
                                            {name}
                                        </Label>
                                        <Input
                                            defaultChecked={form.isNonContiguousItem}
                                            id="isNonContiguousItem"
                                            name="isNonContiguousItem"
                                            type="checkbox"
                                            value={form.isNonContiguousItem}
                                            onChange={handleFormFieldChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col>
                        {
                            isNonContiguous &&
                            <Col sm="6">
                                <FormGroup>
                                    <Input bsSize="sm"
                                        type="select"
                                        value={form.masterWaterwayItemId}
                                        onChange={handleFormFieldChange}
                                        name="masterWaterwayItemId"
                                        id="masterWaterwayItemId"
                                        >
                                            <option value={0} >{selectOption}</option>
                                            {masterWaterwayItemList.filter(x => x.id != itemPopup.itemId).map(c =>
                                            <option key={c.id} value={c.id}>{c.value}</option>
                                        )}
                                    </Input>
                                    </FormGroup>
                                    {formErrors.masterWaterwayItemId != undefined &&
                                        <p className="errorMessage">{formErrors.masterWaterwayItemId}</p>
                                    }
                            </Col>
                        }
                    </Row>
                </>
            }
        </>
    )
}

export default NonContiguousForm